import Head from 'next/head';
import { lazy } from 'react';
import { useMemo } from 'react';

import { useInitialLoad, useIsUserAuthenticated } from '@feed/session';

const Feed = lazy(() => import('@feed/features/timeline'));
const Breadcrumbs = lazy(
	() => import('core/generic/components/navigation/breadcrumbs')
);
const Loading = lazy(() => import('core/generic/elements/loading'));

const FEED_BREADCRUMBS = [
	{
		title: 'My Account',
		href: `${process.env.NEXT_PUBLIC_API_BASE}/account`,
		id: 0,
	},
	{
		title: 'Cityzens Feed',
		href: '/',
		id: 1,
	},
];

const Home = () => {
	const isUserAuthenticated = useIsUserAuthenticated();
	const initialLoad = useInitialLoad();

	const feedPageTitle = useMemo(() => {
		return isUserAuthenticated
			? 'Cityzens - My activity feed'
			: 'Cityzens – Join now for exclusive offers and competitions from Manchester City';
	}, [isUserAuthenticated]);

	const feedPageDescription =
		'Join Cityzens now and get personalised rewards, join in on polls and competitions and get exclusive news and videos.';

	return (
		<>
			<Head>
				<title>{feedPageTitle}</title>
				<meta name="description" content={feedPageDescription} />
				<meta
					property="og:url"
					content={`${process.env.NEXT_PUBLIC_API_BASE}/feed`}
				/>
				<meta property="og:title" content="Be a Cityzen today!" />
			</Head>

			{initialLoad ? (
				<div className="main-loading">
					<Loading dimension="medium" />
				</div>
			) : (
				<main className="main">
					<div className="container">
						<div className="row no-gap">
							<div className="col-12">
								<Breadcrumbs listCrumbs={FEED_BREADCRUMBS} />
							</div>
							<div className="col-12 col-md-6 col-offset-md-3">
								<Feed className="widgets" />
							</div>
						</div>
					</div>
				</main>
			)}
		</>
	);
};

export default Home;
